import { Component, Input, OnInit } from '@angular/core';
import { TrackingEventGroup } from '../../../models/tracking-event-group';
import { Shipment } from '../../../models/shipment';
import { TrackingEvent } from '../../../models/tracking-event';
import { Clock } from 'src/app/utils/clock';
import { DateService } from '../../shared/services/date.service';


interface EventDisplay {
    event: TrackingEvent;
    showDate: boolean;
    showCountry: boolean;
    showLocation: boolean;
    location: string;
    first: boolean;
    last: boolean;
    day: string;
    month: string;
    country: string;
}

interface GroupDisplay {
    group: TrackingEventGroup;
    first: boolean;
    last: boolean;
}

@Component({
    selector: 'app-tracking-group',
    templateUrl: './tracking-group.component.html',
    styleUrls: ['./tracking-group.component.scss'],
    imports: []
})
export class TrackingGroupComponent implements OnInit {

    @Input()
    public shipment: Shipment;

    @Input()
    public group: TrackingEventGroup;

    public displayPackageTracking = false;
    public packageTrackingNumbers: string[] = [];
    public events: EventDisplay[] = [];
    public groups: GroupDisplay[] = [];

    constructor(private dateService: DateService) {
    }

    ngOnInit(): void {
        this.initializeGroups();
        this.initializeEvents();
    }

    initializeGroups(): void {
        if (this.group.packageIds.length < this.shipment.packages.length) {
            this.displayPackageTracking = true;
            this.packageTrackingNumbers = this.shipment.packages
                .filter(p => this.group.packageIds.indexOf(p.id) !== -1)
                .map(p => p.trackingNumber);
        }
        this.group.split.forEach((g, index, arr) => {
            const groupDisplay: GroupDisplay = {
                group: g,
                first: index === 0,
                last: index === (arr.length - 1)
            };
            this.groups.push(groupDisplay);
        });
    }

    initializeEvents(): void {
        let currentDate = '';
        let currentCountry = this.shipment.shipper.country;
        let currentLocation = '';

        this.group.events.forEach((e, index, arr) => {
            const location = [ e.terminal, e.city, e.province ].filter(p => !!p).join(', ');
            const eventDisplay: EventDisplay = {
                event: e,
                showDate: e.date !== currentDate,
                showCountry: !!e.country && e.country !== currentCountry,
                showLocation: !!location && location !== currentLocation,
                location,
                first: index === 0,
                last: this.group.split.length === 0 && index === (arr.length - 1),
                day: Clock.dayNumber(e.date),
                month: this.dateService.renderShortMonthName(e.date),
                country: e.country
            };
            currentDate = e.date;
            currentCountry = e.country;
            currentLocation = location;
            this.events.push(eventDisplay);
        });
    }

}
